export default __webpack_public_path__ + "static/media/iceCream.ca6c0a98.webp";